<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'フロア・表示グループ情報' | translate}}</h1>

  <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="openAddDialog()">
      <mat-icon>add</mat-icon>
      <span>{{'追加' | translate}}</span>
    </button>

    <button mat-raised-button color="warn" (click)="deleteData()" [disabled]="!selection.selected.length">
      <mat-icon>delete</mat-icon>
      <span>{{'削除' | translate}}</span>
    </button>
  </div>
</div>

<div class="filter-field">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let floor; let i = index"> {{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef> {{'編集' | translate}} </th>
      <td mat-cell *matCellDef="let floor">
        <button mat-button color="primary" (click)="openEditDialog(floor)">
          <mat-icon>create</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef> {{'削除' | translate}} </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox color="warn" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="floor_id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> ID </th>
      <td mat-cell *matCellDef="let floor"> {{ floor.floor_id }} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'名称' | translate}} </th>
      <td mat-cell *matCellDef="let floor"> {{ floor.floor_names | multiName:projectLanguages:projectBaseLang }} </td>
    </ng-container>

    <ng-container matColumnDef="explain">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'説明' | translate}} </th>
      <td mat-cell *matCellDef="let floor"> {{ floor.floor_explain }} </td>
    </ng-container>

    <ng-container matColumnDef="file">
      <th mat-header-cell *matHeaderCellDef> {{'画像' | translate}} </th>
      <td mat-cell *matCellDef="let floor">
        <img *ngIf="!!floor.floor_files[0]"
          [src]="(floor.floor_files[0].file_id | doc:uploadedFilesCollectionName | async)?.download_url" height="40px"
          width="auto">
      </td>
    </ng-container>

    <ng-container matColumnDef="exhibit">
      <th mat-header-cell *matHeaderCellDef> {{'展示数' | translate}} </th>
      <td mat-cell *matCellDef="let floor"> {{ !!floor.exhibit_ids ? floor.exhibit_ids.length:0 }} {{'件' |
        translate}}</td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'更新日時' | translate}} </th>
      <td mat-cell *matCellDef="let floor"> {{ floor.updated.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>